import React from "react";
import { REQUEST_STATUS_MAP } from "./nocStatusConstants";

interface RequestStatusBadgeProps {
  status: string;
}

const RequestStatusBadge: React.FC<RequestStatusBadgeProps> = ({ status }) => {
  const currentStatus = REQUEST_STATUS_MAP[status] || {
    label: status || "-",
    class: "badge-secondary",
  };

  return <span className={`badge ${currentStatus.class}`}>{currentStatus.label}</span>;
};

export default RequestStatusBadge;
